import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import client from "../api/client"

export const useNFTs = (page = 1, limit = 9) => {
  return useQuery({
    queryKey: ["nfts", page, limit],
    queryFn: () => client.get(`/nfts?page=${page}&limit=${limit}`).then((res) => res.data)
  })
}

export const useNFT = (id) => {
  return useQuery({
    queryKey: ["nft", id],
    queryFn: () => client.get(`/nfts/${id}`).then((res) => res.data),
    enabled: !!id,
  })
}

export const useCreateNFT = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data) => client.post("/nfts", data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["nfts"] })
    },
  })
}

export const usePurchaseNFT = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data) => client.post("/nfts/purchase", data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["portfolio"] })
    },
  })
}

export const usePortfolio = (page = 1, limit = 9) => {
  return useQuery({
    queryKey: ["portfolio", page, limit],
    queryFn: () => client.get(`/users/portfolio?page=${page}&limit=${limit}`).then((res) => res.data),
    enabled: !!localStorage.getItem("token"),
  })
}
